var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "vidirect-title" },
        [
          _c("custom-breadcrumb"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "add-btn",
              on: {
                click: function($event) {
                  return _vm.$refs["createVidirect"].showCreateDialog()
                }
              }
            },
            [_vm._v("Add New Retailer")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-box" },
        [
          _c("el-input", {
            staticClass: "search_input",
            attrs: {
              "prefix-icon": "el-icon-search",
              placeholder: "Retailer Name/Store Name/Phone/Email/Remark",
              clearable: ""
            },
            model: {
              value: _vm.selectData.keyWords,
              callback: function($$v) {
                _vm.$set(_vm.selectData, "keyWords", $$v)
              },
              expression: "selectData.keyWords"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "search-btn",
              attrs: { type: "primary" },
              on: { click: _vm.search }
            },
            [_vm._v("Search\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page_table" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.vidirectData,
                stripe: "",
                height: "calc(100vh - 300px)",
                size: "small",
                "header-cell-style": _vm.headerCellStyle,
                "cell-style": _vm.cellStyle
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "Username",
                  prop: "username",
                  width: "180",
                  fixed: ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                staticStyle: { "box-shadow": "0 0 10px #06c" },
                attrs: {
                  label: "Email",
                  prop: "email",
                  width: "220",
                  fixed: ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Store name", prop: "storeName", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Phone", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.phone) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Address", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.fulladdress) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Remark1", prop: "remark", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Total Credit", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          $" +
                            _vm._s(scope.row.totalCredit) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Net terms status", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.handleNetTermsStatus(scope.row.netTermStatus)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Reviewer / Review time", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.reviewer) +
                            "\n          "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.handleReviewTime(scope.row.reviewTime)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Bonded Status", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.handleBondedStatus(scope.row.isBonded)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("Pagination", {
            attrs: {
              currentPage: _vm.selectData.currentPage,
              total: _vm.total,
              pageSize: _vm.selectData.pageSize
            },
            on: {
              handleSizeChange: _vm.handleSizeChange,
              handleCurrentChange: _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("create-vidirect", { ref: "createVidirect" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f9d0f00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f9d0f00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vidirect/vidirect-list.vue
// module id = AKcy
// module chunks = 2